import { render, staticRenderFns } from "./TreeFacetFilter.vue?vue&type=template&id=6f4fcc4a&"
import script from "./TreeFacetFilter.vue?vue&type=script&lang=js&"
export * from "./TreeFacetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports